import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import useOnMount from '../../hooks/useOnMount';

const SafeRedirect = (props) => {
	const [hasRenderedOnce, setHasRenderedOnce] = useState(false);

	useOnMount(() => {
		setHasRenderedOnce(true);
	});

	if(hasRenderedOnce) return null;

	return <Redirect {...props} />;
};

export default SafeRedirect;
